import React from 'react';
import { Icon, ICONS, PLATFORM_THEME_COLORS, Typography } from '@thinknet-gmbh/platform-common-ui';

export const FileDownloadLink = ({
  file,
}: {
  file?: {
    location: string;
    filename: string;
  };
}) => {
  return file?.location ? (
    <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
      <a target="_blank" rel="noopener noreferrer" href={file?.location} title={'file'}>
        {file?.filename}
      </a>
      <Icon
        icon={ICONS.downloadSolid}
        rightMargin={false}
        color={PLATFORM_THEME_COLORS.primary.blue}
        size={16}
      />
    </Typography>
  ) : (
    <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>-</Typography>
  );
};

export default FileDownloadLink;
